import { render, staticRenderFns } from "./PersonReferences.vue?vue&type=template&id=098487bd&scoped=true"
import script from "./PersonReferences.vue?vue&type=script&lang=js"
export * from "./PersonReferences.vue?vue&type=script&lang=js"
import style0 from "./PersonReferences.vue?vue&type=style&index=0&id=098487bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098487bd",
  null
  
)

export default component.exports